import React from 'react';
import { ArrowRight, Zap } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { AnimateOnScroll } from '../hooks/useScrollAnimation';
import { useLanguage } from '../LanguageContext';

const FinalCTA = () => {
  const navigate = useNavigate();
  const { t, language } = useLanguage();

  return (
    <section className="py-10 md:py-16 px-4 md:px-8">
      <AnimateOnScroll animation="fade-up">
        <div className="max-w-xl mx-auto">
          {/* Card avec bordure subtile */}
          <div className="relative bg-gradient-to-br from-zinc-900/80 to-zinc-950/90 border border-cyan-900/40 rounded-xl md:rounded-2xl p-6 md:p-8 overflow-hidden">
            
            {/* Glow effect en arrière-plan */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-48 h-48 bg-cyan-500/10 rounded-full blur-3xl pointer-events-none"></div>
            
            {/* Contenu */}
            <div className="relative z-10 text-center">
              {/* Badge */}
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-cyan-700/50 bg-cyan-950/50 mb-4 md:mb-5">
                <Zap className="w-3.5 h-3.5 text-cyan-400" />
                <span className="text-cyan-400 text-xs font-medium">
                  {language === 'FR' ? 'Lancez-vous' : 'Get Started'}
                </span>
              </div>
              
              {/* Titre */}
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-3 md:mb-4 leading-tight">
                {language === 'FR' ? (
                  <>Libérez la <span className="text-cyan-400">puissance</span> de votre PC</>
                ) : (
                  <>Unleash the <span className="text-cyan-400">power</span> of your PC</>
                )}
              </h2>
              
              {/* Sous-titre */}
              <p className="text-gray-400 text-xs md:text-sm mb-5 max-w-sm mx-auto">
                {language === 'FR' 
                  ? 'Rejoignez +4500 gamers satisfaits et profitez d\'une expérience de jeu optimale'
                  : 'Join +4500 satisfied gamers and enjoy an optimal gaming experience'
                }
              </p>
              
              {/* Bouton CTA */}
              <button
                onClick={() => navigate('/services')}
                className="group inline-flex items-center gap-2 px-6 py-3 bg-cyan-600 hover:bg-cyan-500 text-white font-semibold text-sm md:text-base rounded-lg transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-cyan-500/25"
              >
                <Zap className="w-4 h-4" />
                {language === 'FR' ? 'Voir les offres' : 'See offers'}
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </button>
            </div>
          </div>
        </div>
      </AnimateOnScroll>
    </section>
  );
};

export default FinalCTA;
